<template>
  <div class="outerCon">
    <div class="title">
      医保目录对照表上传
    </div>
    <div class="cardCon">
      <div class="left">
        <div class="firstLine">
          <div class="first-line-first">药房目录</div>
            <div class="first-line-second">药店目录信息:</div>
            <lk-input  placeholder="请输入编码/名称/批准文号" style="width: 160px; margin-right:40px" clearable v-model.trim="queryStore.nameMix"></lk-input>
            <lk-button class="btn" type='primary' @click="handleStoreClick">查询</lk-button>
          </div>
        <div class="table-left">
          <lk-table border :loading='storeLoading' :columns='columnsDrugStore' :data='tableDataDrugStore' height="300" :highlight-row='true' @on-current-change="getCurrentRowStore"></lk-table>
        </div>
        <div class="pages">
          <lk-page :total="store.count" :current.sync='queryStore.page' show-total @on-change="pageChangeStore" :page-size='20' />
        </div>
      </div>
      <div class="left">
        <div class="firstLine">
          <div class="first-line-first">医保中心目录</div>
          <div class="first-line-second">医保中心目录信息:</div>
          <lk-input  placeholder="请输入编码/名称/批准文号" style="width: 160px; margin-right:40px" clearable v-model.trim="queryInsurance.drugNameOrCode"></lk-input>
          <lk-button class="btn" type='primary' @click="handleSearchInsurance">查询</lk-button>
        </div>
        <div class="table-left">
          <lk-table border :loading='insuranceLoading' :columns='columnsInsurance' :data='tableDataInsurance' height="300" :highlight-row='true' @on-current-change="getCurrentRowInsurance"></lk-table>
        </div>
        <div class="pages">
          <lk-page :total="insurance.count" show-total @on-change="pageChangeInsurance" :page-size='20' />
        </div>
      </div>
    </div>
    <div class="comparedCon">
      <lk-button class="btnReserve" type='primary' @click="reserveMatch">保存匹配</lk-button>
      <lk-button  type='primary' @click="confirmMatch">确认匹配</lk-button>
    </div>
    <div>
      <lk-table border :columns='columnsCurrent' :data='afterMatchRow'></lk-table>
    </div>
  </div>
</template>
<script>
import utils from '../../../libs/utils';
import goodsStore from '../../../services/goods';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import insurance from '../../../services/insuranceLanzhou';

export default {
  name: 'CatalogCompared',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: false,
      store: {
        count: null,
      },
      insurance: {
        count: null,
      },
      queryStore: {
        nameMix: '',
        page: 1,
        size: 20,
      },
      queryInsurance: {
        code: '',
        page: 1,
        size: 20,
      },
      columnsDrugStore: [
        {
          type: 'index',
          minWidth: 60,
        },
        {
          title: '商品编码',
          key: 'goodsBaseDrugSerialCode',
          minWidth: 80,
          tooltip: true,
        },
        {
          title: '药品通用名',
          key: 'goodsBaseApprovedDrugNames',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'goodsBaseSpecifications',
          minWidth: 80,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'goodsBaseVODosageFormString',
          minWidth: 80,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'goodsBaseManufacturer',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '批准文号',
          key: 'goodsBaseApprovalNumber',
          minWidth: 100,
          tooltip: true,
        },
      ],
      columnsInsurance: [
        {
          type: 'index',
          minWidth: 60,
        },
        {
          title: '药品编码',
          key: 'medListCodg',
          minWidth: 90,
          tooltip: true,
        },
        {
          title: '药品名称',
          key: 'goodsName',
          minWidth: 90,
          tooltip: true,
        },
        {
          title: '批准文号',
          key: 'approvalCode',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'produceName',
          minWidth: 90,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 90,
          tooltip: true,
        },
      ],
      columnsCurrent: [
        {
          title: '药店商品编码',
          key: 'goodsBaseDrugSerialCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心商品编码',
          key: 'medListCodg',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店通用名称',
          key: 'goodsBaseApprovedDrugNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心通用名称',
          key: 'goodsName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店规格',
          key: 'goodsBaseSpecifications',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店剂型',
          key: 'goodsBaseVODosageFormString',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店生产厂家',
          key: 'goodsBaseManufacturer',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店批准文号',
          key: 'goodsBaseApprovalNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批准文号',
          key: 'approvalCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'produceName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '操作',
          minWidth: 60,
          fixed: 'right',
          render: (h, params) => {
            return h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.afterMatchRow.splice(params.index, 1);
                },
              },
            }, '删除');
          },
        },
      ],
      storeLoading: false,
      insuranceLoading: false,
      tableData: [],
      tableDataDrugStore: [],
      tableDataInsurance: [],
      currentRowStore: [],
      currentRowInsurance: [],
      afterMatchRow: [],
    };
  },
  methods: {
    pageChangeStore(e) {
      this.queryStore.page = e;
      this.handleSearchStore(this.queryStore);
    },
    pageChangeInsurance(e) {
      this.queryInsurance.page = e;
      this.handleSearchInsurance(this.queryInsurance);
    },
    getCurrentRowStore(newVal) {
      this.currentRowStore = [newVal];
    },
    getCurrentRowInsurance(e) {
      this.currentRowInsurance = [e];
    },
    confirmMatch() {
      if (!this.currentRowStore.length || !this.currentRowInsurance.length) {
        this.$Message.error('请正确选择药品目录信息');
        return;
      }
      const value1 = this.currentRowStore[0];
      const value2 = this.currentRowInsurance[0];
      const { goodsBaseDrugSerialCode, goodsBaseApprovedDrugNames } = value1;
      const { type, medListCodg } = value2;
      this.afterMatchRow.forEach((item) => {
        if (item.goodsBaseDrugSerialCode === goodsBaseDrugSerialCode && item.medListCodg === medListCodg) {
          this.$Message.error('药品已经匹配过，请重新选择');
          return;
        }
      });
      const obj = {
        fixmedinsHilistId: goodsBaseDrugSerialCode,
        fixmedinsHilistName: goodsBaseApprovedDrugNames,
        listType: type,
        medListCodg: medListCodg,
      };
      const temp = Object.assign({}, value1, value2, obj);
      this.afterMatchRow.push(temp);
      this.currentRowStore = [];
      this.currentRowInsurance = [];
    },
    reserveMatch() {
      if (!this.afterMatchRow.length) {
        this.$Message.error('请先匹配药品');
        return;
      }
      const direMatches = utils.deepClone(this.afterMatchRow);
      const temp = {
        direMatches: direMatches,
      };
      insurance.uploadDir(temp).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        } else {
          this.$Message.success('保存成功');
          this.afterMatchRow = [];
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
    handleStoreClick() {
      this.queryStore.page = 1;
      this.handleSearchStore();
    },
    handleSearchStore() {
      const params = this.queryStore;
      this.storeLoading = true;
      goodsStore.listGoodsStores(params).then((res) => {
        this.storeLoading = false;
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        } else {
          this.tableDataDrugStore = [];
          this.store.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableDataDrugStore.push(result);
          });
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleInsuranceClick() {
      this.queryStore.page = 1;
      this.handleSearchInsurance();
    },
    handleSearchInsurance() {
      const params = this.queryInsurance;
      this.insuranceLoading = true;
      insurance.getInsuranceDir(params).then((res) => {
        this.insuranceLoading = false;
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        } else {
          this.tableDataInsurance = [];
          this.insurance.count = res.data.data.count;
          this.tableDataInsurance = res.data.data.list;
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.outerCon {
    width: 100%;
    height: 680px;
}
.title {
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
}
.left {
    width: 49%;
    height: 400px;
    background-color: #ffffff;
}
.cardCon {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.firstLine {
    height: 40px;
    display: flex;
    align-items: center;
}
.first-line-first {
    height: 40px;
    width: auto;
    line-height: 40px;
    margin: 0 20px 0 20px;
}
.first-line-second {
   margin-right: 10px;
}
.table-left {
    margin-top: 10px;
}
.pages {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}
.comparedCon {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 10px;
    margin-bottom: 10px;
}
.btnReserve {
    margin-left: 20px;
}
</style>
